import { render, staticRenderFns } from "./ModalNewTypeService.vue?vue&type=template&id=0a288ed0"
import script from "./ModalNewTypeService.vue?vue&type=script&lang=js"
export * from "./ModalNewTypeService.vue?vue&type=script&lang=js"
import style0 from "./ModalNewTypeService.vue?vue&type=style&index=0&id=0a288ed0&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a288ed0')) {
      api.createRecord('0a288ed0', component.options)
    } else {
      api.reload('0a288ed0', component.options)
    }
    module.hot.accept("./ModalNewTypeService.vue?vue&type=template&id=0a288ed0", function () {
      api.rerender('0a288ed0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/services/components/ModalNewTypeService.vue"
export default component.exports